import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Key, BarChart3, Zap, Shield, Database } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

export const Home = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-blue-50" data-testid="home-page">
      {/* Hero Section */}
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img src="/logo.png" alt="Cangkir Wanesia" className="h-24 w-24 object-contain" />
          </div>
          
          <div className="inline-flex items-center space-x-2 bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full mb-6">
            <Package className="h-5 w-5" />
            <span className="text-sm font-medium">Logistics API Platform</span>
          </div>
          
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Cangkir Wanesia
          </h1>
          
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
            Indonesian Location Data & Shipping Cost API. Fast, reliable, and easy to integrate.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex items-center justify-center space-x-4 mb-16">
            <Link to="/login">
              <Button size="lg" data-testid="login-button">
                Get Started
              </Button>
            </Link>
            <a href="/docs" target="_blank" rel="noopener noreferrer">
              <Button size="lg" variant="outline" data-testid="docs-button">
                View API Docs
              </Button>
            </a>
          </div>
          
          {/* Features */}
          <div className="grid md:grid-cols-3 gap-6 mt-16">
            <Card data-testid="feature-locations">
              <CardContent className="pt-6">
                <Database className="h-12 w-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="text-lg font-semibold mb-2">Location Data</h3>
                <p className="text-sm text-gray-600">
                  Complete Indonesian location data from Province to District
                </p>
              </CardContent>
            </Card>
            
            <Card data-testid="feature-shipping">
              <CardContent className="pt-6">
                <Package className="h-12 w-12 text-blue-600 mx-auto mb-4" />
                <h3 className="text-lg font-semibold mb-2">Shipping Cost</h3>
                <p className="text-sm text-gray-600">
                  Real-time shipping cost calculation with smart caching
                </p>
              </CardContent>
            </Card>
            
            <Card data-testid="feature-security">
              <CardContent className="pt-6">
                <Shield className="h-12 w-12 text-purple-600 mx-auto mb-4" />
                <h3 className="text-lg font-semibold mb-2">Secure & Fast</h3>
                <p className="text-sm text-gray-600">
                  JWT authentication with rate limiting protection
                </p>
              </CardContent>
            </Card>
          </div>
          
          {/* Stats */}
          <div className="grid md:grid-cols-3 gap-8 mt-16 max-w-3xl mx-auto">
            <div>
              <div className="text-4xl font-bold text-emerald-600 mb-2">35</div>
              <div className="text-sm text-gray-600">Provinces</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-blue-600 mb-2">500+</div>
              <div className="text-sm text-gray-600">Cities</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-purple-600 mb-2">99.9%</div>
              <div className="text-sm text-gray-600">Uptime</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};